import React, { useState, useEffect } from 'react'
import { Form, FormGroup, Label, Input, Table } from 'reactstrap'
import { getStudentIdData, addData, updateData } from '../../lib/studentbragsheet'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'
import { useAuth } from '../../_helper/Auth/AuthProvider'

const BragSheet = ({ studentId }) => {
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [grade, setGrade] = useState('')
	const [deadline, setDeadline] = useState('')
	const [testScore, setTestScore] = useState('')
	const [extActivity, setExtActivity] = useState('')
	const [award, setAward] = useState('')
	const [threeAdjective, setThreeAdjective] = useState('')
	const [hobby, setHobby] = useState('')
	const [mostProud, setMostProud] = useState('')
	const [strengWeakness, setStrengWeakness] = useState('')
	const [obstacle, setObstacle] = useState('')
	const [recommendation, setRecommendation] = useState('')
	const [recId, setRecId] = useState(0)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState('')
	const [isDarkMode, setIsDarkMode] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const { user } = useAuth()
	const effectiveStudentId = studentId || user?.id

	const getData = async () => {
		try {
			setLoading(true)
			setError('')
			const data = await getStudentIdData(effectiveStudentId)
			if (data.length > 0) {
				setRecId(data[0].id)
				setName(data[0].name || '')
				setEmail(data[0].email || '')
				setGrade(data[0].grade || '')
				setDeadline(data[0].deadline || '')
				setTestScore(data[0].testScore || '')
				setExtActivity(data[0].extActivity || '')
				setAward(data[0].award || '')
				setThreeAdjective(data[0].threeAdjective || '')
				setHobby(data[0].hobby || '')
				setMostProud(data[0].mostProud || '')
				setStrengWeakness(data[0].strengWeakness || '')
				setObstacle(data[0].obstacle || '')
				setRecommendation(data[0].recommendation || '')
			}
		} catch (error) {
			console.error('Error fetching brag sheet:', error)
			setError('Failed to load brag sheet')
		} finally {
			setLoading(false)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			const formData = {
				studentId: effectiveStudentId,
				name,
				email,
				grade,
				deadline,
				testScore,
				extActivity,
				award,
				threeAdjective,
				hobby,
				mostProud,
				strengWeakness,
				obstacle,
				recommendation
			}

			if (recId > 0) {
				await updateData({ id: recId, ...formData })
			} else {
				await addData(formData)
			}

			showToastMessage('Update successful!')
			window.scrollTo(0, 0)
			await getData() // Refresh data
		} catch (error) {
			console.error('Error saving brag sheet:', error)
			setError('Failed to save brag sheet')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (effectiveStudentId) {
			getData()
		}
	}, [effectiveStudentId])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	const textareaStyle = {
		backgroundColor: isDarkMode ? '#2a2d35' : '#CFE2F3',
		color: isDarkMode ? '#fff' : 'inherit',
		borderColor: '#6FA8DC',
		resize: 'vertical',
		minHeight: '80px'
	}

	const inputStyle = {
		backgroundColor: isDarkMode ? '#2a2d35' : '#CFE2F3',
		color: isDarkMode ? '#fff' : 'inherit',
		borderColor: '#6FA8DC'
	}

	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="card-header border-bottom d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center">
					<button
						type="button"
						className="btn btn-link p-0 me-2"
						data-bs-toggle="collapse"
						data-bs-target="#collapseBragSheet"
						aria-expanded="false"
						aria-controls="collapseBragSheet"
					>
						<i className="fa fa-chevron-down"></i>
					</button>
					<h5 className="mb-0 d-inline-block">Brag Sheet</h5>
				</div>
			</div>
			<div className="collapse" id="collapseBragSheet">
				<div className="card-body">
					{error && (
						<div className="alert alert-danger alert-dismissible fade show" role="alert">
							<strong>Error:</strong> {error}
							<button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></button>
						</div>
					)}

					{loading ? (
						<div className="text-center">
							<div className="spinner-border" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
							<p className="mt-2">Loading brag sheet...</p>
						</div>
					) : (
						<>
							<div className="text-center mb-4">
								<h3 style={{ color: isDarkMode ? '#fff' : 'inherit' }}>SENIOR BRAG SHEET</h3>
								<h4 style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Letter of Recommendation Request</h4>
							</div>

							<Form onSubmit={handleSubmit}>
								{/* Contact Info Table */}
								<div className="table-responsive mb-4">
									<Table bordered>
										<thead>
											<tr className="bg-primary text-white">
												<th colSpan={4} className="text-center">
													<h5 className="mb-0">Contact Info</h5>
												</th>
											</tr>
											<tr className="bg-primary text-white">
												<th>Name</th>
												<th>Email</th>
												<th>Grade</th>
												<th>Deadline</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<Input
														type="text"
														value={name}
														onChange={(e) => setName(e.target.value)}
														className="form-control"
														style={inputStyle}
														placeholder="Enter name"
													/>
												</td>
												<td>
													<Input
														type="email"
														value={email}
														onChange={(e) => setEmail(e.target.value)}
														className="form-control"
														style={inputStyle}
														placeholder="Enter email"
													/>
												</td>
												<td>
													<Input
														type="number"
														value={grade}
														onChange={(e) => setGrade(e.target.value)}
														className="form-control"
														style={inputStyle}
														placeholder="Grade"
													/>
												</td>
												<td>
													<Input
														type="date"
														value={deadline}
														onChange={(e) => setDeadline(e.target.value)}
														className="form-control"
														style={inputStyle}
													/>
												</td>
											</tr>
										</tbody>
									</Table>
								</div>

								{/* Test Scores */}
								<FormGroup className="mb-3">
									<Label htmlFor="testScore" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										Test Scores:
									</Label>
									<Input
										type="textarea"
										id="testScore"
										value={testScore}
										onChange={(e) => setTestScore(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter test scores"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Extracurricular Activities */}
								<FormGroup className="mb-3">
									<Label htmlFor="extActivity" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										Extracurricular Activities:
									</Label>
									<Input
										type="textarea"
										id="extActivity"
										value={extActivity}
										onChange={(e) => setExtActivity(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter extracurricular activities"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Awards */}
								<FormGroup className="mb-3">
									<Label htmlFor="award" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										Awards:
									</Label>
									<Input
										type="textarea"
										id="award"
										value={award}
										onChange={(e) => setAward(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter awards"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Three Adjectives */}
								<FormGroup className="mb-3">
									<Label htmlFor="threeAdjective" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										Character Traits: Three adjectives that describe me and why:
									</Label>
									<Input
										type="textarea"
										id="threeAdjective"
										value={threeAdjective}
										onChange={(e) => setThreeAdjective(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter three adjectives and why"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Hobbies */}
								<FormGroup className="mb-3">
									<Label htmlFor="hobby" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										My hobbies, interests, and talents:
									</Label>
									<Input
										type="textarea"
										id="hobby"
										value={hobby}
										onChange={(e) => setHobby(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter hobbies, interests, and talents"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Most Proud */}
								<FormGroup className="mb-3">
									<Label htmlFor="mostProud" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										What I'm most proud of:
									</Label>
									<Input
										type="textarea"
										id="mostProud"
										value={mostProud}
										onChange={(e) => setMostProud(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter what you're most proud of"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Strengths and Weaknesses */}
								<FormGroup className="mb-3">
									<Label htmlFor="strengWeakness" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										My strength and weaknesses:
									</Label>
									<Input
										type="textarea"
										id="strengWeakness"
										value={strengWeakness}
										onChange={(e) => setStrengWeakness(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter strengths and weaknesses"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Specific to this class */}
								<FormGroup className="mb-3">
									<Label htmlFor="obstacle" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										Specific to this class:
									</Label>
									<Input
										type="textarea"
										id="obstacle"
										value={obstacle}
										onChange={(e) => setObstacle(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter information specific to this class"
										style={textareaStyle}
									/>
								</FormGroup>

								{/* Recommendation */}
								<FormGroup className="mb-3">
									<Label htmlFor="recommendation" className="form-control-label fw-bold mb-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
										What I would include if I wrote your own recommendation:
									</Label>
									<Input
										type="textarea"
										id="recommendation"
										value={recommendation}
										onChange={(e) => setRecommendation(e.target.value)}
										rows="3"
										className="form-control border-radius-10"
										placeholder="Enter what you would include"
										style={textareaStyle}
									/>
								</FormGroup>

								<hr />

								<div className="d-flex justify-content-end">
									<button type="submit" className="btn btn-primary" disabled={loading}>
										<i className="fa fa-save me-2"></i>
										{loading ? 'Updating...' : 'Update BragSheet'}
									</button>
								</div>
							</Form>
						</>
					)}
				</div>
			</div>
		</div>
	)
}

export { BragSheet }
